// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"styles_tabsWrapper__sZ13l","tabItem":"styles_tabItem__B1QAM","selected":"styles_selected__-G2wK"};